import React, { ReactNode, useMemo, useState } from 'react'
import { ApplicationFormContext } from "../lib/ApplicationFormContext";
import { ApplicationAddresses } from 'shared/api/assurant/quotePayloadTypes';
import { JourneyResult } from 'shared/config/types/customerResponse';

interface Props {
	children?: ReactNode;
}

const ApplicationFormProvider = ({ children }: Props) => {
	const [applicationFormData, setApplicationFormData] = useState<JourneyResult | null>(null);
	const [applicationAddress, setApplicationAddress] = useState<ApplicationAddresses>(
		{
			mailingAddress: {
				address1: '',
				address2: '',
				city: '',
				state: '',
				postalCode: '',
			},
			billing: {
				address: {
					address1: '',
					address2: '',
					city: '',
					state: '',
					postalCode: '',
				},
				firstName: '',
				lastName: '',
			},
			propertyAddress: {
				address1: '',
				address2: '',
				city: '',
				state: '',
				postalCode: '',
			}
		}
	);
	const defaultProps = useMemo(() => ({
		applicationAddress,
		applicationFormData,
		setApplicationAddress,
		setApplicationFormData,
	}), [applicationAddress, applicationFormData, setApplicationAddress, setApplicationFormData]);

	return (
		<ApplicationFormContext.Provider value={defaultProps}>
			{children}
		</ApplicationFormContext.Provider>
	)
}

export default ApplicationFormProvider;
